import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/api/baseQueries";

const NEWS_TAGS = ["PassiveNews"];

export const newsApi = createApi({
  reducerPath: "newsApi",
  tagTypes: NEWS_TAGS,
  baseQuery: customBaseQuery(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_ZOOMAPP_BACKEND_BASE_URL}/news`,
    }),
  ),
  endpoints: (builder) => ({
    getPassiveNews: builder.query({
      query: () => ({ url: "/passive", method: "GET" }),
      providesTags: NEWS_TAGS,
    }),
    dismissPassiveNews: builder.mutation({
      query: (newsId) => ({
        url: "/dismiss",
        method: "POST",
        body: { newsId },
      }),
      invalidatesTags: NEWS_TAGS,
    }),
  }),
});

export const { useGetPassiveNewsQuery, useDismissPassiveNewsMutation } =
  newsApi;
